import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

interface CTASectionProps {
  category: string;
}

export default function CTASection({ category }: CTASectionProps) {
  return (
    <section className="py-16 lg:py-24 bg-gradient-to-br from-primary to-secondary">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl lg:text-4xl font-heading font-semibold text-primary-foreground mb-6">
            Ready to Start Your Treatment Journey?
          </h2>
          <p className="text-lg text-primary-foreground/90 mb-8 max-w-2xl mx-auto">
            Get personalized care from licensed physicians and have your treatment delivered directly to your door
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              href={`/multi-tier-checkout?category=${category}`}
              className="flex items-center justify-center gap-2 px-8 py-4 bg-primary-foreground text-primary rounded-lg font-medium transition-smooth hover:shadow-elevation-xl hover:scale-[0.97]"
            >
              <Icon name="ShoppingCartIcon" size={20} />
              Browse Products
            </Link>
            <Link
              href="/registration"
              className="flex items-center justify-center gap-2 px-8 py-4 border-2 border-primary-foreground text-primary-foreground rounded-lg font-medium transition-smooth hover:bg-primary-foreground hover:text-primary"
            >
              <Icon name="UserPlusIcon" size={20} />
              Create Account
            </Link>
          </div>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-6 text-primary-foreground/80">
            <div className="flex items-center gap-2">
              <Icon name="ShieldCheckIcon" size={20} />
              <span className="text-sm">HIPAA Compliant</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="TruckIcon" size={20} />
              <span className="text-sm">Free Shipping</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="ClockIcon" size={20} />
              <span className="text-sm">24/7 Support</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}